import api from './api'
import CryptoJS from "crypto-js"

export const urls = {
  // GET_CPR_GERADAS: "http://localhost:4600/financial/listCpr?status=gerada",
  GET_CPR_GERADAS: "/financial/listCpr?status=gerada",
  GET_CPR_ATENCIPACAO_PROGRAMADA: "/financial/listCpr?status=anticipate",
  GET_CPR_BALANCE: "/system/config?key=BACKOFFICE_CPR_BALANCE",
  GET_CPR_PENDENTES_ASSINATURA: "/financial/getPendingSignarureCprs",
  GET_LIST_FARMHOUSE: "/financial/listFarmHouse",
  GET_USERS: "/subscription/getUserSubscribed",
  GET_LIST_PERSONNE: "/subscription/listPersonne",
  GET_LIST_OPPORTUNITIES: "/financial/opportunities/admin",
  GET_LIST_ALL_OPPORTUNITIES:
    "/financial/opportunities/admin/all",
  GET_LIST_ALL_CPRFS_BY_OPPORTUNITY:
    "/financial/opportunities/getCprs",
  GET_SUMMARIZATION: "/financial/cpr/summarization",
  GET_BOI_GORDO: "/financial/indicators/getFatCattle",
  PUT_BOI_GORDO: "/financial/indicators/editCattlePrice",
};

export const GetFetch = async (url, params) => {
  try {
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_TOKEN_ENCRYPT_HASH);
    var JWT = bytes.toString(CryptoJS.enc.Utf8);
    api.defaults.headers.authorization = `Bearer ${JWT}`;

    const data = await api.get(url, params)
    return data
  } catch (err) { 
    throw err
  }
}

export const PostFetch = async (url, params) => {
  try {
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_TOKEN_ENCRYPT_HASH);
    var JWT = bytes.toString(CryptoJS.enc.Utf8);
    api.defaults.headers.authorization = `Bearer ${JWT}`;

    const data = await api.post(url, params)
    return data
  } catch (err) { 
    throw err
  }
}

export const PutFetch = async (url, params) => {
  try {
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_TOKEN_ENCRYPT_HASH);
    var JWT = bytes.toString(CryptoJS.enc.Utf8);
    api.defaults.headers.authorization = `Bearer ${JWT}`;

    const data = await api.put(url, params)
    return data
  } catch (err) { 
    throw err
  }
}

export const GetToken = () => {
  const ciphertext = localStorage.getItem('@JWT_HASH')
  var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_TOKEN_ENCRYPT_HASH);
  return bytes.toString(CryptoJS.enc.Utf8);
}

export const DeleteFetch = async (url, params) => {
  try {
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_TOKEN_ENCRYPT_HASH);
    var JWT = bytes.toString(CryptoJS.enc.Utf8);
    api.defaults.headers.authorization = `Bearer ${JWT}`;

    const data = await api.delete(url, params)
    return data
  } catch (err) { 
    throw err
  }
}